(function () {
  'use strict';

  // Format prices as US dollars without decimals (assuming prices are in dollars no cents)
  const formatPrice = (priceInCents) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(priceInCents / 100);
  };

  // Additional initialization after main setup
  function postInit() {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('size')) {
      const sizeParam = urlParams.get('size');
      if (sizeParam === '6') {
        const pill6CountBox = document.querySelector('.selection-pill[data-value="6 Coffees"]');
        pill6CountBox.click();
      }
    }
  }

  // MutationObserver to watch for .rb-options element to appear in the DOM
  function setupRbOptionsObserver() {
    // Check if element already exists
    const existingElement = document.querySelector('.rb-options');
    if (existingElement) {
      setupReChargeElements();
      return;
    }

    // Create observer to watch for .rb-options to be added
    const observer = new MutationObserver((mutations, obs) => {
      const rbOptionsElement = document.querySelector('.rb-options');
      if (rbOptionsElement) {
        setupReChargeElements();
        obs.disconnect(); // Stop observing once element is found
      }
    });

    // Start observing the document body for child additions
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  let numberOfCoffeesElem = {
    selectElem: null,
    option3Elem: null,
    option6Elem: null
  };
  let grindSelectElem = {
    selectElem: null,
    optionWholeBeanElem: null,
    optionGroundCoffeeElem: null
  };
  let frequencySelectElem = {
    selectElem: null,
    optionMonthlyElem: null,
    option3MonthPrepaidElem: null,
    option6MonthPrepaidElem: null
  };

  /**
   * Get the prepaid price for a specific box count and prepaid duration
   * @param {Object} boxConfig - The BoxConfig object
   * @param {number} boxCount - 3 or 6
   * @param {string} prepaidDuration - '3-month' or '6-month'
   * @returns {number|null} - The price in cents or null if not found
   */
  function getPrepaidPrice(boxConfig, boxCount, prepaidDuration) {
    if (!boxConfig || !boxConfig.product) return null;

    // Find the variant for the specified box count (using Whole Bean as default)
    const variant = boxConfig.product.variants.find(v => {
      const matchesCount = boxCount === 3
        ? v.title.includes('3 Coffees')
        : v.title.includes('6 Coffees');
      const matchesGrind = v.title.includes('Whole Bean');
      return matchesCount && matchesGrind;
    });

    if (!variant) return null;

    // Find the selling plan group for the prepaid duration
    const planGroup = boxConfig.product.selling_plan_groups.find(
      group => group.name.includes(prepaidDuration === '3-month' ? '3 month prepaid' : '6 month prepaid')
    );

    if (!planGroup) return null;

    // Find the selling plan allocation in the variant that matches this plan group
    const allocation = variant.selling_plan_allocations.find(
      alloc => alloc.selling_plan_group_id === planGroup.id
    );

    // Return the price from the allocation (per_delivery_price is the actual price per delivery)
    return allocation ? allocation.per_delivery_price : null;
  }

  /**
   * Get the selling plan ID from BoxConfig based on current variant and frequency type
   * @param {Object} boxConfig - The BoxConfig object
   * @param {string} frequencyType - 'monthly', '3-month', or '6-month'
   * @returns {number|null} - The selling plan ID or null if not found
   */
  function getSellingPlanId(boxConfig, frequencyType) {
    if (!boxConfig || !boxConfig.product) return null;

    // Find the current variant based on buildConfig
    const variant = boxConfig.product.variants.find(v => {
      const matchesCount = buildConfig.count === 3
        ? v.title.includes('3 Coffees')
        : v.title.includes('6 Coffees');
      const matchesGrind = buildConfig.grind === 'whole bean'
        ? v.title.includes('Whole Bean')
        : v.title.includes('Ground Coffee');
      return matchesCount && matchesGrind;
    });

    if (!variant) return null;

    // Find the selling plan group
    let planGroup = null;
    if (frequencyType === 'monthly') {
      planGroup = boxConfig.product.selling_plan_groups.find(
        group => group.name.includes('Delivery Every Month')
      );
    } else if (frequencyType === '3-month') {
      planGroup = boxConfig.product.selling_plan_groups.find(
        group => group.name.includes('3 month prepaid')
      );
    } else if (frequencyType === '6-month') {
      planGroup = boxConfig.product.selling_plan_groups.find(
        group => group.name.includes('6 month prepaid')
      );
    }

    if (!planGroup) return null;

    // Find the selling plan allocation in the variant that matches this plan group
    const allocation = variant.selling_plan_allocations.find(
      alloc => alloc.selling_plan_group_id === planGroup.id
    );

    return allocation ? allocation.selling_plan_id : null;
  }

  /**
   * Helper function to set frequency select value by finding the option with matching data-selling-plan-id
   * Since option values are [object Object], we need to find options by their data attribute
   * @param {HTMLElement} selectElement - The select element to update
   * @param {string|number} sellingPlanId - The selling plan ID to match (as string or number)
   */
  function setFrequencySelectBySellingPlanId(selectElement, sellingPlanId) {
    if (!selectElement || !sellingPlanId) return;

    // Convert to string for comparison
    const planIdStr = String(sellingPlanId);

    const options = Array.from(selectElement.querySelectorAll('option'));
    const targetOption = options.find(option => {
      const planId = option.getAttribute('data-selling-plan-id');
      return planId === planIdStr;
    });

    if (targetOption) {
      // Set the option as selected
      options.forEach(opt => opt.selected = false);
      targetOption.selected = true;
      // Trigger change event to notify ReCharge
      selectElement.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  let addToCartButtonElem = null;

  // All the .rb-item inputs values
  let statusBarElementsSetup = false; // Flag to prevent duplicate event listeners

  const statusBarElems = {
    textCountElem: '#custom-status-bar__select-text__count',
    textCountElem2: '#custom-status-bar__counter',
    servingsElem: '#custom-status-bar__servings'
  }

  let buildConfig = {
    count: 3, // 3 or 6
    grind: 'whole bean', // 'whole bean' or 'ground coffee'
    prepaidSubscription: null, // null, 3, or 6
    bestSeller: false, // true or false
    products: [], // array of product ids
  }

  // Store boxConfig globally so it's accessible to all functions
  let boxConfig = null;

  function setupReChargeElements() {
    const optionsContainer = document.querySelector('.rb-form > div:not(.rb-btn-wrapper)');

    Array.from(optionsContainer.querySelectorAll('.rb-field')).forEach(field => {
      const label = field.querySelector('.rb-label');
      const select = field.querySelector('.rb-select');
      const options = Array.from(field.querySelectorAll('option'));

      if (label.textContent.includes('Number of Coffees')) {
        numberOfCoffeesElem.selectElem = select;
        numberOfCoffeesElem.option3Elem = options.find(option => option.textContent.includes('3 Coffees'));
        numberOfCoffeesElem.option6Elem = options.find(option => option.textContent.includes('6 Coffees'));
      } else if (label.textContent.includes('Grind')) {
        grindSelectElem.selectElem = select;
        grindSelectElem.optionWholeBeanElem = options.find(option => option.textContent.includes('Whole Bean'));
        grindSelectElem.optionGroundCoffeeElem = options.find(option => option.textContent.includes('Ground Coffee'));
      } else if (label.textContent.includes('Frequency')) {
        frequencySelectElem.selectElem = select;
        frequencySelectElem.optionMonthlyElem = options.find(option => option.textContent.includes('Delivery Every Month'));
        frequencySelectElem.option3MonthPrepaidElem = options.find(option => option.textContent.includes('3 month prepaid'));
        frequencySelectElem.option6MonthPrepaidElem = options.find(option => option.textContent.includes('6 month prepaid'));
      }
    });

    const addToCartButton = document.querySelector('.rb-sticky-form .rb-container .rb-form > .rb-btn-wrapper > button.rb-btn');
    if (addToCartButton) {
      addToCartButtonElem = addToCartButton;
    }

    setupStatusBarElements();

    // Initialize frequency select to monthly subscription if boxConfig is available
    // This ensures the correct selling plan is selected on page load
    if (frequencySelectElem.selectElem && boxConfig) {
      const monthlySubscriptionToggle = document.getElementById('monthly-subscription-toggle');
      if (monthlySubscriptionToggle && monthlySubscriptionToggle.checked) {
        const sellingPlanId = getSellingPlanId(boxConfig, 'monthly');
        if (sellingPlanId) {
          setFrequencySelectBySellingPlanId(frequencySelectElem.selectElem, sellingPlanId);
        }
      }
    }
  }

  function setupStatusBarElements() {
    // Prevent duplicate event listeners
    if (statusBarElementsSetup) {
      return;
    }

    const rbItems = Array.from(document.querySelectorAll('.rb-items-wrapper .rb-item'));
    rbItems.forEach(item => {
      const input = item.querySelector('.rb-input');
      if (input) {
        input.addEventListener('change', checkStatusBar);
      }
      const minusButton = item.querySelector('.rb-btn-qty-minus');
      if (minusButton) {
        minusButton.addEventListener('click', checkStatusBar);
      }
      const plusButton = item.querySelector('.rb-btn-qty-plus');
      if (plusButton) {
        plusButton.addEventListener('click', checkStatusBar);
      }
    });

    statusBarElementsSetup = true; // Mark as setup to prevent duplicate listeners
  }

  function checkStatusBar() {
    const total = getInputValues().reduce((acc, curr) => acc + parseInt(curr), 0);
    const statusBarElem = document.querySelector('.custom-status-bar__main-line');
    const textCountElem2 = document.querySelector(statusBarElems.textCountElem2);

    textCountElem2.textContent = total;

    if (buildConfig.count === 3) {
      if (total === 3) {
        statusBarElem.classList.add('clickable');
      } else {
        statusBarElem.classList.remove('clickable');
      }
    } else if (buildConfig.count === 6) {
      if (total === 6) {
        statusBarElem.classList.add('clickable');
      } else {
        statusBarElem.classList.remove('clickable');
      }
    }

    const bestSellerToggle = document.getElementById('best-seller-toggle');
    bestSellerToggle.checked = areBestSellersSelected();

    const sectionElement = document.querySelector('.coffee-club-main__inner');
    const cupsPerItem = parseInt(sectionElement.dataset.cupsPerItem || '39', 10);
    const espressoShotsPerItem = parseInt(sectionElement.dataset.espressoShotsPerItem || '28', 10);

    // Calculate and update servings
    const totalCups = total * cupsPerItem;
    const totalShots = total * espressoShotsPerItem;

    const servingsElem = document.querySelector("#custom-status-bar__servings")
    if (servingsElem) {
      servingsElem.textContent = `Total: ${totalCups} CUPS / ${totalShots} SHOTS`;
    }

  }

  function getInputValues() {
    const rbItems = Array.from(document.querySelectorAll('.rb-items-wrapper .rb-item'));
    const inputValues = [];
    rbItems.forEach((item, index) => {
      const input = item.querySelector('.rb-input');
      if (input) {
        inputValues[index] = parseInt(input.value || '0');
      }
    });
    return inputValues;
  }

  function areBestSellersSelected() {
    const rbItems = Array.from(document.querySelectorAll('.rb-items-wrapper .rb-item'));
    let toReturn = true;
    let selectedCount = 0;
    rbItems.forEach((item, index) => {
      const input = item.querySelector('.rb-input');
      const value = parseInt(input?.value || '0');

      if (index < buildConfig.count) {
        if (!value) {
          toReturn = false;
        }
      }

      selectedCount += value;
    });
    if (selectedCount > buildConfig.count) {
      toReturn = false;
    }

    return toReturn;
  }

  function init() {
    if (window.BoxConfig) {
      setupRbOptionsObserver();

      boxConfig = window.BoxConfig;

      // Get the price of the 3-count box and 6-count box
      const price3CountBox = boxConfig.product.variants.find(variant => variant.title.includes('3')).price;
      const price6CountBox = boxConfig.product.variants.find(variant => variant.title.includes('6')).price;

      // Format the prices as US dollars without decimals
      const formattedPrice3 = formatPrice(price3CountBox);
      const formattedPrice6 = formatPrice(price6CountBox);

      // Get the elements for the 3-count box and 6-count box
      const price3CountBoxElement = document.querySelector('.selection-pill[data-value="3 Coffees"]');
      const price6CountBoxElement = document.querySelector('.selection-pill[data-value="6 Coffees"]');

      // Set the prices for the 3-count box and 6-count box
      price3CountBoxElement.innerHTML = `3-COUNT BOX - ${formattedPrice3}`;
      price6CountBoxElement.innerHTML = `6-COUNT BOX - ${formattedPrice6}`;

      // Get prepaid prices for each box size and duration from variant allocations
      const price3MonthPrepaid3Count = getPrepaidPrice(boxConfig, 3, '3-month');
      const price3MonthPrepaid6Count = getPrepaidPrice(boxConfig, 6, '3-month');
      const price6MonthPrepaid3Count = getPrepaidPrice(boxConfig, 3, '6-month');
      const price6MonthPrepaid6Count = getPrepaidPrice(boxConfig, 6, '6-month');

      // Format the prices as US dollars without decimals
      const formattedPrice3MonthPrepaid3Count = formatPrice(price3MonthPrepaid3Count);
      const formattedPrice3MonthPrepaid6Count = formatPrice(price3MonthPrepaid6Count);
      const formattedPrice6MonthPrepaid3Count = formatPrice(price6MonthPrepaid3Count);
      const formattedPrice6MonthPrepaid6Count = formatPrice(price6MonthPrepaid6Count);

      // Get the elements for the 3-month prepaid subscription and 6-month prepaid subscription
      const pill3CountBox = document.querySelector('.selection-pill[data-value="3 Coffees"]');
      const pill6CountBox = document.querySelector('.selection-pill[data-value="6 Coffees"]');
      const pill3MonthPrepaidSubscription = document.querySelector('.selection-pill[data-value="3 month prepaid subscription"]');
      const pill6MonthPrepaidSubscription = document.querySelector('.selection-pill[data-value="6 month prepaid subscription"]');

      // Set the default selected count to 3
      pill3CountBox.classList.add('active');

      const wholeBeanPill = document.querySelector('.selection-pill[data-value="Whole Bean"]');
      const groundCoffeePill = document.querySelector('.selection-pill[data-value="Ground Coffee"]');

      // Set the default selected grind to whole bean
      wholeBeanPill.classList.add('active');


      function resetFromVariantChange() {
        statusBarElementsSetup = false;
        checkStatusBar();

        const bestSellerToggle = document.getElementById('best-seller-toggle');
        bestSellerToggle.checked = areBestSellersSelected();

        // Store current frequency selection before reset
        const currentFrequencyType = buildConfig.prepaidSubscription === 3
          ? '3-month'
          : buildConfig.prepaidSubscription === 6
            ? '6-month'
            : 'monthly';

        setTimeout(() => {
          setupReChargeElements();

          // Re-apply the frequency selection after ReCharge elements are reset
          // This ensures the correct selling plan ID is used for the new variant
          if (frequencySelectElem.selectElem && boxConfig) {
            const sellingPlanId = getSellingPlanId(boxConfig, currentFrequencyType);
            if (sellingPlanId) {
              setFrequencySelectBySellingPlanId(frequencySelectElem.selectElem, sellingPlanId);
            }
          }
        }, 500);
      }

      function handleGrindClick(event) {
        const pill = event.target;
        wholeBeanPill.classList.remove('active');
        groundCoffeePill.classList.remove('active');
        pill.classList.add('active');
        buildConfig.grind = pill.dataset.value.includes('Whole Bean') ? 'whole bean' : 'ground coffee';
        if (buildConfig.grind === 'whole bean') {
          grindSelectElem.selectElem.value = grindSelectElem.optionWholeBeanElem.value;
        } else {
          grindSelectElem.selectElem.value = grindSelectElem.optionGroundCoffeeElem.value;
        }
        grindSelectElem.selectElem.dispatchEvent(new Event('change'));

        resetFromVariantChange();
      }

      wholeBeanPill.addEventListener('click', handleGrindClick);
      groundCoffeePill.addEventListener('click', handleGrindClick);

      function handleCountBoxClick(event) {
        const pill = event.target;
        pill3CountBox.classList.remove('active');
        pill6CountBox.classList.remove('active');
        pill.classList.add('active');
        buildConfig.count = pill.dataset.value.includes('3') ? 3 : 6;

        const textCountElem = document.querySelector(statusBarElems.textCountElem);
        textCountElem.textContent = buildConfig.count;

        if (buildConfig.count === 3) {
          numberOfCoffeesElem.selectElem.value = numberOfCoffeesElem.option3Elem.value;
        } else {
          numberOfCoffeesElem.selectElem.value = numberOfCoffeesElem.option6Elem.value;
        }
        numberOfCoffeesElem.selectElem.dispatchEvent(new Event('change'));

        resetFromVariantChange();
      }

      function handlePrepaidSubscriptionClick(event) {
        const pill = event.target;
        if (pill.classList.contains('active')) {
          monthlySubscriptionToggle.click(); // click the monthly subscription toggle
        } else {
          pill3MonthPrepaidSubscription.classList.remove('active');
          pill6MonthPrepaidSubscription.classList.remove('active');
          pill.classList.add('active');
          
          // Determine which prepaid option was selected
          buildConfig.prepaidSubscription = pill.dataset.value.includes('3') ? 3 : 6;

          // Set prices based on selected prepaid duration
          // Each box size has its own price within each prepaid plan
          if (buildConfig.prepaidSubscription === 3) {
            price3CountBoxElement.innerHTML = `3-COUNT BOX - ${formattedPrice3MonthPrepaid3Count}`;
            price6CountBoxElement.innerHTML = `6-COUNT BOX - ${formattedPrice3MonthPrepaid6Count}`;
          } else {
            price3CountBoxElement.innerHTML = `3-COUNT BOX - ${formattedPrice6MonthPrepaid3Count}`;
            price6CountBoxElement.innerHTML = `6-COUNT BOX - ${formattedPrice6MonthPrepaid6Count}`;
          }

          // Use the helper function to set the correct selling plan based on current variant
          const frequencyType = buildConfig.prepaidSubscription === 3 ? '3-month' : '6-month';
          const sellingPlanId = getSellingPlanId(boxConfig, frequencyType);
          if (sellingPlanId && frequencySelectElem.selectElem) {
            setFrequencySelectBySellingPlanId(frequencySelectElem.selectElem, sellingPlanId);
          }
        }

        resetFromVariantChange();
      }

      pill3CountBox.addEventListener('click', handleCountBoxClick);
      pill6CountBox.addEventListener('click', handleCountBoxClick);
      pill3MonthPrepaidSubscription.addEventListener('click', handlePrepaidSubscriptionClick);
      pill6MonthPrepaidSubscription.addEventListener('click', handlePrepaidSubscriptionClick);

      // Get the monthly subscription toggle
      const monthlySubscriptionToggle = document.getElementById('monthly-subscription-toggle');

      // Handle the monthly subscription toggle
      function handleMonthlySubscriptionToggle(event) {
        const checked = event.target.checked;
        if (checked) {
          // unselect the 3-month prepaid subscription and 6-month prepaid subscription
          pill3MonthPrepaidSubscription.classList.remove('active');
          pill6MonthPrepaidSubscription.classList.remove('active');

          // Set the prices for the 3-count box and 6-count box
          price3CountBoxElement.innerHTML = `3-COUNT BOX - ${formattedPrice3}`;
          price6CountBoxElement.innerHTML = `6-COUNT BOX - ${formattedPrice6}`;

          // Use the helper function to set the monthly subscription selling plan
          const sellingPlanId = getSellingPlanId(boxConfig, 'monthly');
          if (sellingPlanId && frequencySelectElem.selectElem) {
            setFrequencySelectBySellingPlanId(frequencySelectElem.selectElem, sellingPlanId);
          }
        } else {
          // select the 3-month prepaid subscription
          pill3MonthPrepaidSubscription.classList.add('active');
          pill6MonthPrepaidSubscription.classList.remove('active');

          // Set prices for 3-month prepaid (each box size has its own price)
          price3CountBoxElement.innerHTML = `3-COUNT BOX - ${formattedPrice3MonthPrepaid3Count}`;
          price6CountBoxElement.innerHTML = `6-COUNT BOX - ${formattedPrice3MonthPrepaid6Count}`;

          // Use the helper function to set the 3-month prepaid subscription selling plan
          const sellingPlanId = getSellingPlanId(boxConfig, '3-month');
          if (sellingPlanId && frequencySelectElem.selectElem) {
            setFrequencySelectBySellingPlanId(frequencySelectElem.selectElem, sellingPlanId);
          }
        }
      }

      monthlySubscriptionToggle.addEventListener('change', handleMonthlySubscriptionToggle);

      /**
       * Fill with best seller logic
       */
      const bestSellerToggle = document.getElementById('best-seller-toggle');
      async function handleBestSellerToggle(event) {
        event.preventDefault();
        event.stopPropagation();
        const checked = event.target.checked;

        // uncheck all currently checked items
        const rbItems = Array.from(document.querySelectorAll('.rb-items-wrapper .rb-item'));

        if (checked) {
          // Go over any inputs greater than the first best sellers and set them to 0
          rbItems.forEach((item, index) => {
            const input = item.querySelector('.rb-input');
            if (input && parseInt(input.value) > 0 && index >= buildConfig.count) {
              input.value = 0;
              input.dispatchEvent(new Event('change'));
            }
          });

          await new Promise(resolve => setTimeout(resolve, 100));

          // check the best selling products
          const bestSellingProducts = Array.from(document.querySelectorAll('.rb-items-wrapper .rb-item')).filter((item, index) => index < buildConfig.count);
          // Process products sequentially to ensure delays between operations
          for (const product of bestSellingProducts) {
            const addButton = product.querySelector('.rb-btn-qty-plus');
            const input = product.querySelector('.rb-input');
            // If not already selected, click the add button to add 1
            if (addButton && parseInt(input.value) < 1) {
              addButton.click();
            }
            // already selected but has more than 1, set to 1
            else if (input && parseInt(input.value) > 1) {
              input.value = 1;
              input.dispatchEvent(new Event('change'));
            }
            await new Promise(resolve => setTimeout(resolve, 100)); // small delay between clicks
          }
        } else {
          rbItems.forEach((item, index) => {
            const input = item.querySelector('.rb-input');
            if (input && parseInt(input.value) > 0 && index < buildConfig.count) {
              input.value = 0;
              input.dispatchEvent(new Event('change'));
            }
          });
        }

        await new Promise(resolve => setTimeout(resolve, 100));
        checkStatusBar();
      }
      bestSellerToggle.addEventListener('click', handleBestSellerToggle);

      // Handle submission
      const addToCartButton = document.querySelector('.custom-status-bar__main-line');
      function handleAddToCart() {
        if (addToCartButton.classList.contains('clickable')) {
          const addonsHeader = document.querySelector('.rb-addons-header');
          const addonsContainer = addonsHeader.nextElementSibling;
          const addButton = addonsContainer.querySelector('.rb-btn-qty-plus');
          addButton.click();
          setTimeout(() => {
            addToCartButtonElem.click();
          }, 100);
        }
      }
      addToCartButton.addEventListener('click', handleAddToCart);

      postInit();
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      setupRbOptionsObserver();
    });
  } else {
    init();
    setupRbOptionsObserver();
  }
})();
